import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const PartyLedgerPage = lazy(() => import("@/pages/reports.ledger-party.page"));

export const Route = createFileRoute("/reports/ledger-party")({
  component: PartyLedgerPage,
});
